import { useState, useEffect } from 'react';
import { Modal, Spin, Typography, Alert } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { getStoresForPageVersion } from '../../services/pageversionservice';

interface Store {
    storeNumber: string;
}

interface StoresListModalProps {
    open: boolean;
    onClose: () => void;
    pageVersionGuid: string | null;
}

const StoresListModal = ({ open, onClose, pageVersionGuid }: StoresListModalProps) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [stores, setStores] = useState<Store[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (open && pageVersionGuid) {
            const fetchStores = async () => {
                setLoading(true);
                setError(null);
                try {
                    const data = await getStoresForPageVersion(pageVersionGuid);
                    setStores(data);
                } catch (err) {
                    console.error("Failed to fetch stores:", err);
                    setError("Failed to load stores. Please try again.");            
                } finally {
                    setLoading(false);
                }
            };
            fetchStores();
        } else {
            setStores([]);
            setError(null);
        }
    }, [ open, pageVersionGuid]);

    const formattedStores = stores.map(store => store.storeNumber).join(', ');

    return (
        <Modal
            title={<span style={{ color: '#1890ff' }}><ShopOutlined style={{ marginRight: 4 }} />Published to Stores</span>}
            open={open}
            onCancel={onClose}
            footer={null}
            width={900}
            style={{ padding: '24px' }}
        >
            {error && <Alert message={error} type="error" showIcon style={{ marginBottom: '10px' }} />}

            {loading ? (
                <Spin tip="Loading stores..." style={{ display: 'block', margin: '20px auto' }} />
            ) : stores.length > 0 ? (
                <Typography.Paragraph
                    style={{
                        padding: '10px 15px',
                        border: '1px solid #f0f0f0',
                        borderRadius: '8px',
                        backgroundColor: '#f9f9f9',
                        boxShadow: 'none',
                        fontSize: '1.1em',
                        lineHeight: '1.6',
                        color: '#333',
                        wordBreak: 'break-word',
                    }}
                >
                    {formattedStores}
                </Typography.Paragraph>
            ) : (
                <Typography.Text type="secondary">No stores found for this page version.</Typography.Text>
            )}
        </Modal>
    );
};

export default StoresListModal;
